import React, { useContext } from 'react';
export const SegmentedControlContext = React.createContext({
    onChange: () => { },
    value: '',
});
export const useSegmentedControlContext = () => {
    return useContext(SegmentedControlContext);
};
//# sourceMappingURL=segment-control-context.js.map